import { useToast } from '@hooks/useToast';
import { queryFetch } from '@services/api';
import { useMutation } from '@tanstack/react-query';
import { downloadFile } from '@utils/downloadFile';
import { useTranslation } from 'react-i18next';
import { DownloadIssueImageBody } from './types';
import { useAccess } from '@hooks/access';

export const useDownloadIssueImage = () => {
  const { t } = useTranslation('app', { keyPrefix: 'errors' });
  const access = useAccess();
  const { toast } = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ issueId, imageId }: DownloadIssueImageBody) =>
      queryFetch<Response>({
        url: `${
          access.fieldUser ? 'foreman/' : ''
        }issues/${issueId}/download_image?image_id=${imageId}`,
        blob: true,
        opt: { method: 'GET' },
      }),
    onSettled: async (res?: Response) => {
      if (res?.ok && res?.status === 200) downloadFile(await res.blob(), res.headers);
      else {
        toast({
          title: t('download'),
          variant: 'destructive',
        });
      }
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
